module.exports = __webpack_public_path__ + "img/no_coupon.7f5646ae.png";